// Light/dark theme. 'system' follows the device. Applied via the `dark` class on
// <html> (Tailwind darkMode:'class'). The initial class is set by an inline script
// in index.html to avoid a flash before React mounts.
export type Theme = 'light' | 'dark' | 'system';
const KEY = 'ajm-theme';

export function getTheme(): Theme {
  if (typeof window === 'undefined') return 'system';
  const v = window.localStorage.getItem(KEY);
  return v === 'light' || v === 'dark' || v === 'system' ? v : 'system';
}

export function resolvedDark(theme: Theme): boolean {
  if (theme === 'dark') return true;
  if (theme === 'light') return false;
  return window.matchMedia('(prefers-color-scheme: dark)').matches;
}

export function applyTheme(theme: Theme) {
  document.documentElement.classList.toggle('dark', resolvedDark(theme));
}

export function setTheme(theme: Theme) {
  window.localStorage.setItem(KEY, theme);
  applyTheme(theme);
}
